import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import Eye from '../Icons/Eye.js';
import EyeOff from '../Icons/EyeOff.js';
const VisibilityToggle = ({ visible, onChange, className, style }) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement(Toggle, { type: "button", onClick: () => onChange(!visible), visible: visible, "aria-pressed": visible, className: className, style: style },
        visible ? React.createElement(Eye, null) : React.createElement(EyeOff, null),
        React.createElement("span", null, lang.interactions.visibilityCheckText)));
};
export default VisibilityToggle;
const Toggle = styled.button `
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: ${(props) => props.visible ? THEME.ACCENT_SURFACE : 'rgba(165, 165, 165, 0.12)'};
  border: 1px solid
    ${(props) => props.visible ? THEME.ACCENT_BORDER : 'rgba(165, 165, 165, 0.25)'};
  color: ${(props) => (props.visible ? THEME.COLOR_ACCENT : THEME.COLOR_GREY)};
  padding: 5px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition:
    background 0.15s ease,
    color 0.15s ease,
    border-color 0.15s ease;

  svg {
    width: 14px;
    height: 14px;
  }

  &:hover {
    background: ${(props) => props.visible ? THEME.ACCENT_SURFACE_STRONG : 'rgba(165, 165, 165, 0.2)'};
  }

  &:focus-visible {
    outline: 2px solid ${THEME.COLOR_ACCENT};
    outline-offset: 1px;
  }
`;
//# sourceMappingURL=VisibilityToggle.js.map